import React from 'react';
import { ButtonVariantsEnum } from '../Button/Button.types';
import { Button } from '..';
import { DefaultThemed } from '../ThemeProvider/ThemeProvider';
import {
  StyledCookiesContentWrapper,
  StyledCookiesWrapperBar,
  StyledLink,
} from './CookiesBar.styled';
import { CookiesBarProps } from './CookiesBar.types';

export const CookiesBar: React.FC<CookiesBarProps> = ({
  cookiesPrefix,
  cookiesPolicyUrl,
  cookiesPolicyLabel,
  agreeTxt,
  zIndex,
}: CookiesBarProps) => {
  const [isCookiesApproved, setIsCookiesApproved] = React.useState(
    Boolean(localStorage.getItem('cookiesConsent') === 'true'),
  );

  const onClickHandler = (): void => {
    localStorage.setItem('cookiesConsent', 'true');
    setIsCookiesApproved(true);
  };

  return (
    <DefaultThemed>
      <StyledCookiesWrapperBar {...{ zIndex, isCookiesApproved }}>
        <StyledCookiesContentWrapper>
          {cookiesPrefix}&nbsp;
          <StyledLink href={cookiesPolicyUrl} target="_blank">
            {cookiesPolicyLabel}
          </StyledLink>
        </StyledCookiesContentWrapper>
        <Button
          typeStyle={ButtonVariantsEnum.Outlined}
          size="small"
          onClick={() => onClickHandler()}
        >
          {agreeTxt}
        </Button>
      </StyledCookiesWrapperBar>
    </DefaultThemed>
  );
};
